<template>
  <div :class="outerRotateStage" id="loopImages">
    <div :class="rotateStageClass" id="loopStage" @mouseover="stop" @mouseleave="play">
      <ul v-if="imagesData && imagesData.length > 0" :class="innerShowClass" :style="containerStyle">
        <li>
          <a :href="imagesData[imagesData.length - 1].imageLinkRouterName">
            <img :src="imagesData[imagesData.length - 1].backgroundImage" alt="" />
          </a>
        </li>
        <li v-for="(item, index) in imagesData" :key="index">
          <a :href="item.imageLinkRouterName">
            <img :src="item.backgroundImage" alt="" />
          </a>
        </li>
        <li>
          <a :href="imagesData[0].imageLinkRouterName">
            <img :src="imagesData[0].backgroundImage" alt="" />
          </a>
        </li>
      </ul>
      <ul :class="btnClass">
        <li @click="move(loopStageWidth, 1, speed)"></li>
        <li @click="move(loopStageWidth, -1, speed)"></li>
      </ul>
      <ul :class="circularClass">
        <li
          v-for="(item, index) in imagesData"
          :key="index"
          :class="{ dotted: index === currentIndex - 1 }"
          @click="jumpControlImages(index + 1)"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoopPlayImages',
  props: ['imagesData', 'backgroundAppeMode', 'defaultClasses'],
  data() {
    return {
      currentIndex: 1,
      distance: 0,
      transitionEnd: true,
      speed: this.backgroundAppeMode ? 3600 : 30,
      timer: null,
      temp: null
    }
  },
  mounted() {
    this.loopImagesStyle()
    this.DefaultloopImagesEvent()
  },
  computed: {
    loopStageWidth() {
      return document.getElementById('app').clientWidth
    },
    loopStage() {
      return document.getElementById('loopStage')
    },
    containerStyle() {
      return { transform: `translate3d(${this.distance}px, 0, 0)` }
    },
    interval() { return 4000 },
    outerRotateStage() {
      return this.defaultClasses && this.defaultClasses.outerRotateStage ? this.defaultClasses.outerRotateStage : ''
    },
    rotateStageClass() {
      return this.defaultClasses && this.defaultClasses.rotateStage ? this.defaultClasses.rotateStage : ''
    },
    innerShowClass() {
      return this.defaultClasses && this.defaultClasses.innerShow ? this.defaultClasses.innerShow : ''
    },
    btnClass() {
      return this.defaultClasses && this.defaultClasses.btn ? this.defaultClasses.btn : ''
    },
    circularClass() {
      return this.defaultClasses && this.defaultClasses.circular ? this.defaultClasses.circular : ''
    }
  },
  methods: {
    DefaultloopImagesEvent() {
      this.play()
      window.onblur = () => { this.stop() }
      window.onfocus = () => { this.play() }
    },
    loopImagesStyle() {
      this.distance = -this.loopStageWidth
      const imgs = this.loopStage.getElementsByTagName('img')
      for (let i = 0; i < imgs.length; i++) {
        imgs[i].style.width = this.loopStageWidth + 'px'
      }
    },
    move(distance, direction, speed) {
      if (!this.transitionEnd) return
      this.transitionEnd = false
      if (direction === -1) {
        this.currentIndex += distance / this.loopStageWidth
      } else {
        this.currentIndex -= distance / this.loopStageWidth
      }
      if (this.currentIndex > this.imagesData.length) this.currentIndex = 1
      if (this.currentIndex < 1) this.currentIndex = this.imagesData.length
      const target = this.distance + distance * direction
      this.animate(target, direction, speed)
    },
    animate(target, direction, speed) {
      if (this.temp) { window.clearTimeout(this.temp); this.temp = null }
      const totalWidth = this.loopStageWidth * this.imagesData.length
      if ((direction === -1 && target < this.distance) || (direction === 1 && target > this.distance)) {
        this.distance += speed * direction
        this.temp = window.setTimeout(() => { this.animate(target, direction, speed) }, 20)
      } else {
        this.transitionEnd = true
        this.distance = target
        window.clearTimeout(this.temp)
        if (target < -totalWidth) this.distance = -this.loopStageWidth
        if (target > -this.loopStageWidth) this.distance = -totalWidth
      }
    },
    jumpControlImages(index) {
      const direction = index - this.currentIndex >= 0 ? -1 : 1
      const distance = Math.abs(index - this.currentIndex) * this.loopStageWidth
      const speed = Math.abs(index - this.currentIndex) === 0 ? this.speed : Math.abs(index - this.currentIndex) * this.speed
      this.move(distance, direction, speed)
    },
    play() {
      if (this.timer) { window.clearInterval(this.timer); this.timer = null }
      this.timer = window.setInterval(() => { this.move(this.loopStageWidth, -1, this.speed) }, this.interval)
    },
    stop() {
      window.clearInterval(this.timer)
      this.timer = null
    }
  },
  beforeDestroy() {
    this.stop()
  }
}
</script>

<style lang="scss" scoped>
#loopImages {
  width: 100%;
  height: 576px;
  overflow: hidden;
  position: relative;
}

#loopStage {
  width: 100%;
  height: 100%;
  position: relative;

  ul.inner_show,
  ul.loopContainer {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    height: 100%;

    li {
      flex-shrink: 0;
      a { display: block; height: 100%; }
      img { height: 100%; object-fit: cover; }
    }
  }

  ul.loopImages_btn,
  ul.btnOuter {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    list-style: none;

    li {
      width: 40px;
      height: 40px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:first-child::before { content: '<'; color: #fff; font-size: 20px; }
      &:last-child::before { content: '>'; color: #fff; font-size: 20px; }

      &:hover { background: rgba(0, 0, 0, 0.6); }
    }
  }

  ul.loopImages_circular,
  ul.dots {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    list-style: none;
    padding: 0;

    li {
      width: 10px;
      height: 10px;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 50%;
      margin: 0 5px;
      cursor: pointer;

      &.dotted { background: #d02f3d; }
    }
  }
}
</style>
